module.exports = __webpack_public_path__ + "static/media/search-question.07050dcd.svg";